(function ($) {
    $(document).ready(function () {
        
        initModals();
        initBioCraftCarousel();
        initVideoAutoplay();
        initNotifyMeBackInStockSticky();

        if (window.Shopify && Shopify.designMode) {
            document.addEventListener('shopify:section:load', function(event) {
                initBioCraftCarousel(event.target);
                initVideoAutoplay(event.target);
            });

            document.addEventListener('shopify:section:unload', function(event) {
                destroyBioCraftCarousel(event.target);
            });
        }

        function initModals() {
            const $modalTriggers = $('[data-modal-trigger]');
            const $modalClosers = $('[data-modal-close]');
            const $modalBackground = $('[data-modal-background]');

            $modalTriggers.each(function() {
                const $this = $(this);
                const modalId = $this.data('modal-trigger');

                $this.on('click', function() {
                    closeModal();
                    $(`[data-modal-id="${modalId}"]`).fadeIn(300 , function() {
                        $('body').addClass('modal-open');
                    });
                });
            });

            $modalClosers.each(function() {
                const $this = $(this);
                const modalId = $this.data('modal-close');

                $this.on('click', function() {
                    closeModal(modalId);
                });
            });

            $modalBackground.on('click', function() {
                closeModal();
            });

            function closeModal(modalId = null) {
                if (modalId) {
                    $(`[data-modal-id="${modalId}"]`).fadeOut(300 , function() {
                        $('body').removeClass('modal-open');
                    });
                } else {
                    $('[data-modal-id]').fadeOut(300 , function() {
                        $('body').removeClass('modal-open');
                    });
                }
            }
        }

        function initBioCraftCarousel(context) {
            const $scope = context ? $(context) : $(document);
            const $sliders = $scope.find('[data-bio-carousel]');

            if (!$sliders.length) return;

            $sliders.each(function() {
                const $slider = $(this);
                if ($slider.hasClass('slick-initialized')) return;

                buildBioCraftCarousel($slider);
            });
        }

        function buildBioCraftCarousel($slider) {
            const $section = $slider.closest('.bio-craft-carousel');
            const $controls = $section.find('[data-bio-carousel-controls]');

            const slidesMobile = Number($slider.data('slides-mobile')) || 1;
            const slidesLargeMobile = Number($slider.data('slides-large-mobile')) || 2;
            const slidesTablet = Number($slider.data('slides-tablet')) || 3;
            const slidesDesktop = Number($slider.data('slides-desktop')) || 4;
            const slidesLargeDesktop = Number($slider.data('slides-large-desktop')) || 5;
            
            // Read navigation settings from data attributes
            // data attributes come as strings "true"/"false" from Liquid
            const showArrowsAttr = $slider.data('show-arrows');
            const showDotsAttr = $slider.data('show-dots');
            const showArrows = showArrowsAttr === undefined || showArrowsAttr === true || showArrowsAttr === 'true';
            const showDots = showDotsAttr === true || showDotsAttr === 'true';

            if ($controls.length && showArrows) {
                $controls.removeClass('no-js-hidden');
            }

            $slider.on('init reInit', function(event, slick) {
                if (showArrows) {
                    toggleBioCraftControls($controls, slick);
                }
            });

            $slider.slick({
                arrows: showArrows,
                dots: showDots,
                infinite: false,
                nextArrow: window.arrows.icon_next,
                prevArrow: window.arrows.icon_prev,
                slidesToScroll: slidesMobile,
                slidesToShow: slidesMobile,
                mobileFirst: true,
                speed: 600,
                swipe: true,
                swipeToSlide: true,
                touchMove: true,
                responsive: [
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: slidesLargeMobile,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: slidesTablet,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: slidesDesktop,
                        }
                    },
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: slidesLargeDesktop,
                        }
                    }
                ]
            });
        }

        function toggleBioCraftControls($controls, slick) {
            if (!$controls.length || !slick) return;
            $controls.removeClass('no-js-hidden');
            const hide = slick.slideCount <= slick.options.slidesToShow;
            $controls.toggleClass('is-hidden', hide);
        }

        function destroyBioCraftCarousel(context) {
            const $scope = context ? $(context) : $(document);

            $scope.find('[data-bio-carousel].slick-initialized').each(function() {
                const $slider = $(this);
                const $section = $slider.closest('.bio-craft-carousel');

                $section.find('[data-bio-carousel-prev]').off('.bioCarousel');
                $section.find('[data-bio-carousel-next]').off('.bioCarousel');

                $slider.slick('unslick');
            });
        }

        function initVideoAutoplay(context) {
            const $scope = context ? $(context) : $(document);
            const $videos = $scope.find('[data-video-autoplay]');
            if (!$videos.length) return;

            $videos.each(function() {
                const $container = $(this);
                const $iframe = $container.find('iframe');
                
                if (!$iframe.length) return;
                
                const iframe = $iframe[0];
                let hasPlayed = false;
                
                const observer = new IntersectionObserver((entries) => {
                  entries.forEach(entry => {
                    if (entry.isIntersecting && !hasPlayed) {
                      // Update iframe src to include autoplay
                      const currentSrc = iframe.src;
                      if (currentSrc && !currentSrc.includes('autoplay=1')) {
                        iframe.src = currentSrc + (currentSrc.includes('?') ? '&' : '?') + 'autoplay=1';
                        hasPlayed = true;
                      }
                    }
                  });
                }, {
                  threshold: 0.3 // Trigger when 30% of video is visible
                });
                
                observer.observe($container[0]);

            });
        }

        function initNotifyMeBackInStockSticky() {
            const $stickyBtn = $('[data-notify-me-back-in-stock-sticky]');
            const triggerId = $stickyBtn.data('notify-me-back-in-stock-sticky');
            
            if (!$stickyBtn.length) return;

            // find klaviyo bis trigger every 0.5 seconds, when found, remove loading class and clear interval
            const interval = setInterval(() => {
                const $klaviyoBisTrigger = $(`#${triggerId} button.needsclick`);
                if ($klaviyoBisTrigger.length) {
                    $stickyBtn.removeClass('is-loading');
                    clearInterval(interval);

                    // if the url contains ?notify-me=1, show the notify me modal
                    if (window.location.search.includes('notify-me=1')) {
                        $(`#${triggerId} button.needsclick`).click();
                    }
                }
            }, 500);

            $stickyBtn.on('click', function() {
                $(`#${triggerId} button.needsclick`).click();
            })
        }

    });
})(jQuery);